// @flow
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import useGenerateApi from '../hooks/useGenerateApi';
import type { AppData, GenerateApiRequest } from '../types';
import Card from './common/Card';
import CardCTA from './common/CardCTA';
import RecentMessagesChat from './RecentMessagesChat';
import RecentMessagesDrawer from './RecentMessagesDrawer';
import { Icon } from 'bench-internal-theme';

type RecentMessagesCardProps = {
  appData: AppData;
};

const CardCTAContainer = styled.div`
  padding: 20px;
  &:hover {
    background-color: #f9fafc;
    transition: 200ms;
    cursor: pointer;
  }
`;

const RecentMessagesCard = ({ appData }: RecentMessagesCardProps) => {
  const [showDrawer, setShowDrawer] = useState(false);
  const [generatedMessage, setGeneratedMessage] = useState<string>('');

  const requestData: GenerateApiRequest = {
    messages: appData.recentMessages,
    instructions: '',
  };

  const { message, loading, onSubmit, onUpdate, clearMessage } = useGenerateApi(
    appData.clientId,
    requestData,
  );

  const hasMessages = !!appData.recentMessages.length;

  useEffect(() => {
    setGeneratedMessage(message || '');
  }, [message]);
  return (
    <Card
      header={'Recent Messages'}
      headerIcon={<Icon icon={'speechBubble'} />}
      defaultExpanded={hasMessages}
    >
      {showDrawer ? (
        <RecentMessagesDrawer
          open={showDrawer}
          onClose={() => {
            setShowDrawer(false);
            clearMessage();
          }}
          onSubmit={onSubmit}
          onUpdate={onUpdate}
          generatedMessage={generatedMessage}
          loading={loading}
        />
      ) : (
        <div></div>
      )}
      <CardCTAContainer onClick={() => setShowDrawer(true)}>
        <CardCTA label={'Generate a new message to the customer'} />
      </CardCTAContainer>
      <RecentMessagesChat recentMessages={appData.recentMessages} />
    </Card>
  );
};

export default RecentMessagesCard;
